import * as React from 'react';

import CircleCheck16 from './CircleCheck16';

export const circleCheck16 = () => <CircleCheck16 />;

export default {
    title: 'Icon/Line/CircleCheck16',
    component: CircleCheck16,
    parameters: {
        notes: "`import CircleCheck16 from 'box-ui-elements/es/icon/line/CircleCheck16';`",
    },
};
